module.exports = __webpack_public_path__ + "img/1.d965ee71.jpg";